module.exports = __webpack_public_path__ + "img/web.f38e051b.svg";